import { GridRowsProp } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import {
  GridRow,
  PaginationModel
} from 'src/components/kanri/pages/jichitai/PrsStatusReportPage/types';
import { useUserData } from 'src/hooks/common/useUserData';
import { SearchCallerType } from 'src/types/kanri/SearchCallerType';
import { SearchError } from 'src/types/kanri/SearchError';
import { ErrorResponse } from 'src/utilities/restApi/common/types/responses';
import { getReportPrsStatusJobList } from 'src/utilities/restApi/kanri/report/getReportPrsStatusJobList';

type PageInfo = {
  totalRowCount: number;
  hasNextPage: boolean;
  pageSize: number;
};

type HookParams = {
  paginationModel: PaginationModel;
};

export const useQuery = ({ paginationModel }: HookParams) => {
  const [controller, setController] = useState<AbortController>();
  const { userData } = useUserData();
  const [isLoading, setIsLoading] = useState<SearchCallerType | undefined>('system');
  const [error, setError] = useState<SearchError>({ isError: false, reason: undefined });
  const [rows, setRows] = useState<GridRowsProp<GridRow>>([]);
  const [pageInfo, setPageInfo] = useState<PageInfo>({
    totalRowCount: 0,
    hasNextPage: false,
    pageSize: 0,
  });

  useEffect(() => {
    search('user');
  }, [userData, paginationModel]);

  // functions
  const search = (callerType: SearchCallerType) => {
    if (userData) {
      controller?.abort();
      setIsLoading(callerType);
      const newController = new AbortController();
      setController(newController);
      getReportPrsStatusJobList(
        {
          page: paginationModel.page,
          page_size: paginationModel.pageSize,
        },
        newController
      )
        .then((response) => {
          if (response.data) {
            const gridRows: GridRowsProp<GridRow> = response.data.search_results.rows.map((row) => ({
              id: row.jobid,
              jobId: row.jobid,
              fileName: row.filename,
              state: row.state,
              rowCount: row.rowcount ?? undefined,
              jobStart: row.jobstart ?? undefined,
              jobEnd: row.jobend ?? undefined,
            }));
            setRows(gridRows);
            setPageInfo({
              totalRowCount: response.data.search_results.page_info.total_row_count,
              hasNextPage: response.data.search_results.page_info.has_next_page,
              pageSize: paginationModel.pageSize,
            });
          }
        })
        .catch((response: ErrorResponse) => {
          setError({ isError: true, reason: response.error.reason });
        })
        .finally(() => {
          // abort時は次のリクエストのローディングが走るので、ローディングを解除しない
          if (!newController.signal.aborted) {
            setIsLoading(undefined);
          }
        });
    }
  };

  return { isLoading, rows, pageInfo, error, search };
};
